import { render, staticRenderFns } from "./NavBarRisk.vue?vue&type=template&id=0c0204b8"
import script from "./NavBarRisk.vue?vue&type=script&lang=js"
export * from "./NavBarRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports